import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import EmailObjectLabel from './EmailObjectLabel';
import EmailContentLabel from './EmailContentLabel';

import CtnLang from './CtnLang';
import { defaultCkeHtml } from 'src/components/common/ReactCKEditor';
import EmailObjectEditor from 'src/components/common/contentEditor/EmailObjectEditor';
import EmailContentEditor from 'src/components/common/contentEditor/EmailContentEditor';
import useRenderEditor from 'src/hooks/useRenderEditor';

const MassActionMailEditorRender = ({
  fields,
  content,
  object,
  onEditorLoaded,
  onObjectEditorLoaded,
  onChange,
  isWritable,
}) => {
  const { container, rendered } = useRenderEditor();
  const { t } = useTranslation();

  return (
    <div
      style={{
        height: '70%',
        minHeight: '600px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        overflow: 'visible',
      }}
      ref={container}
    >
      {rendered && (
        <>
          <div>
            <div style={{ width: '100%', display: 'flex' }}>
              <EmailObjectLabel title={t('smartmessaging.contentEditor.mail.object')} />
              <div style={{ marginRight: 0, marginLeft: 'auto' }}>
                <CtnLang />
              </div>
            </div>
            <EmailObjectEditor
              container={container}
              config={{
                readOnly: !isWritable,
                fields: fields.fieldsValues.objectFields,
              }}
              events={{
                loaded: event => {
                  onObjectEditorLoaded(event.editor);
                },
                change: onChange,
              }}
              object={object}
            />
          </div>
          <div>
            <EmailContentLabel title={t('smartmessaging.contentEditor.mail.content')} />
            <EmailContentEditor
              container={container}
              config={{
                readOnly: !isWritable,
                fields: fields.fieldsValues.contentFields,
              }}
              events={{
                loaded: event => {
                  onEditorLoaded(event.editor);
                },
                change: onChange,
                instanceReady: event => {
                  if (content) event.editor.setData(content);
                  else event.editor.setData(defaultCkeHtml);
                },
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

MassActionMailEditorRender.propTypes = {
  fields: PropTypes.any.isRequired,
  content: PropTypes.string.isRequired,
  object: PropTypes.string,
  onEditorLoaded: PropTypes.func.isRequired,
  onObjectEditorLoaded: PropTypes.func.isRequired,
  isWritable: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

MassActionMailEditorRender.defaultProps = {
  object: '',
};

export default MassActionMailEditorRender;
